const cards = [
  {
    title: '咒术回战',
    genre: '热血·战斗',
    desc: '咒术师与诅咒的生死对决，少年背负命运踏上战场',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20style%20illustration%20of%20a%20young%20sorcerer%20casting%20a%20powerful%20spell%20with%20glowing%20energy%2C%20intense%20action%20pose%2C%20warm%20amber%20and%20dark%20contrast%20tones%2C%20manga%20art%20style%2C%20clean%20cream%20background%20with%20dramatic%20lighting%20effects&width=600&height=400&seq=card-manga-01&orientation=landscape',
    alt: '咒术回战热血战斗漫画',
    tag: '热门连载',
  },
  {
    title: '进击的巨人',
    genre: '奇幻·战斗',
    desc: '人类与巨人之间的存亡之战，自由之翼翱翔天际',
    img: 'https://readdy.ai/api/search-image?query=An%20epic%20manga%20style%20illustration%20of%20soldiers%20with%20maneuver%20gear%20flying%20through%20a%20city%2C%20dramatic%20perspective%20and%20scale%2C%20warm%20earthy%20tones%20with%20bright%20sky%2C%20manga%20art%20style%2C%20clean%20cream%20background%20with%20cloud%20textures&width=600&height=400&seq=card-manga-02&orientation=landscape',
    alt: '进击的巨人奇幻漫画',
    tag: '神作完结',
  },
  {
    title: '间谍过家家',
    genre: '搞笑·日常',
    desc: '间谍、杀手、超能力少女组成的伪装家庭喜剧',
    img: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20manga%20style%20illustration%20of%20a%20family%20of%20three%20sitting%20together%20in%20a%20cozy%20living%20room%2C%20warm%20gentle%20lighting%2C%20soft%20pastel%20warm%20tones%2C%20manga%20art%20style%2C%20clean%20cream%20background%2C%20peaceful%20atmosphere&width=600&height=400&seq=card-manga-03&orientation=landscape',
    alt: '间谍过家家搞笑日常漫画',
    tag: '好评如潮',
  },
  {
    title: '王者天下',
    genre: '历史·战争',
    desc: '少年将军驰骋战国沙场，一统天下的宏大史诗',
    img: 'https://readdy.ai/api/search-image?query=An%20epic%20manga%20style%20illustration%20of%20ancient%20Chinese%20warriors%20on%20a%20battlefield%20with%20banners%20and%20horses%2C%20grand%20scale%20composition%2C%20warm%20golden%20and%20earth%20tones%2C%20manga%20art%20style%2C%20clean%20cream%20background%20with%20dramatic%20dust%20effects&width=600&height=400&seq=card-manga-04&orientation=landscape',
    alt: '王者天下历史战争漫画',
    tag: '长篇经典',
  },
  {
    title: '排球少年',
    genre: '运动·热血',
    desc: '小个子少年的排球之梦，汗水与团队的热血青春',
    img: 'https://readdy.ai/api/search-image?query=A%20high%20energy%20manga%20style%20illustration%20of%20volleyball%20players%20jumping%20to%20spike%2C%20dynamic%20action%20moment%2C%20warm%20orange%20and%20white%20tones%2C%20manga%20art%20style%20with%20speed%20lines%2C%20clean%20cream%20background%20with%20court%20textures&width=600&height=400&seq=card-manga-05&orientation=landscape',
    alt: '排球少年运动热血漫画',
    tag: '励志佳作',
  },
  {
    title: '东京喰种',
    genre: '黑暗·奇幻',
    desc: '半人半喰种的少年在残酷世界中的挣扎与觉醒',
    img: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20manga%20style%20illustration%20of%20a%20masked%20figure%20in%20an%20urban%20alley%2C%20dramatic%20light%20and%20shadow%20contrast%2C%20warm%20amber%20street%20light%20against%20darkness%2C%20manga%20art%20style%2C%20clean%20cream%20background%20with%20urban%20textures&width=600&height=400&seq=card-manga-06&orientation=landscape',
    alt: '东京喰种黑暗奇幻漫画',
    tag: '经典名作',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精选漫画</h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">编辑精选<strong>免费完整版漫画</strong>佳作，每一部都值得细细品读</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#ranking"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-200 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 right-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">{card.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <h3 className="text-base font-heading text-foreground-900 whitespace-nowrap">{card.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">{card.genre}</span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}